import React from 'react';

const Footer = () => {
    return (
        <footer className="flex text-center px-4 py-8 justify-center">
            <p className="text-sm">Copyright 2023 • Alan Nuari</p>
        </footer>
    );
};

export default Footer;
